import { storyblokEditable, useStoryblokApi} from "@storyblok/react";
import {useAppContext} from "../../context/state";
import {IProjectItem} from "../../types/IProjectItem";
import Project from "../project-history/Project";
import {useEffect, useState} from "react";
import {Spinner} from "../internal/Spinner";
import InfiniteScroll from 'react-infinite-scroll-component';

export default function ProjectTimeline(props: any) {
    const storyblokApi = useStoryblokApi()
    const blok = props.blok;

    // const projects = useAppContext();
    const [projects, setProjects] = useState<IProjectItem[]>([]);
    const [years, setYears] = useState<any>(new Map);
    const [isLoading, setIsLoading] = useState(false);
    const [page, setPage] = useState(1);
    const [hasMore, setHasMore] = useState(true);

    // Ongoing projects are fetched on the server side
    let ongoingProjects = useAppContext();

    useEffect(() => {
        setProjects((prevProjects) => {
            return [...ongoingProjects.data, ...prevProjects,]
        });

    }, [ongoingProjects])


    const fetchData = async () => {
        fetch('/api/projects?limit=2&page=' + page)
            .then(response => response.json())
            .then(async data => {
                if (data.data.length === 0) {
                    setHasMore(false);
                    return;
                }

                setProjects((prevProjects) => {
                    return [...prevProjects, ...data.data]
                });

                setPage(page + 1);
            });
    }


    return (
        <section className={'bg-white'}>
            <div className="mx-auto max-w-7xl space-y-8 px-4 sm:px-6 lg:px-8"  {...storyblokEditable(blok)}>

                {/*<h2 className={'text-3xl lg:text-4xl font-bold text-gray-900'}>*/}
                {/*    Discover past Projects*/}
                {/*</h2>*/}

                {isLoading &&
                    <div className={'mx-auto w-full text-center'}>
                        <Spinner/>
                    </div>}

            </div>

            <InfiniteScroll
                dataLength={projects.length} //This is important field to render the next data
                next={fetchData}
                hasMore={hasMore}
                loader={<div className={'mx-auto w-full text-center'}>
                    <Spinner/>
                </div>}
                endMessage={
                    <p style={{textAlign: 'center'}}>
                        <b>
                            You&apos;ve viewed every single one of our featured projects! Keep in mind that we&apos;ve completed countless other projects that didn&apos;t make this list. Each of our projects is unique and we&apos;re proud of every single one of them.
                        </b>
                    </p>
                }

            >
                {/*{keys.map(year => {*/}
                {/*    const items: Array<IProjectItem> = years.get(year);*/}

                {/*    return <div key={year} className={'max-w-screen-2xl mx-auto  px-4 sm:px-6 lg:px-8'}*/}
                {/*                data-aos={'fade-in'}>*/}
                {/*        <div className={'grid grid-cols-6'}>*/}
                {/*            <div className={'col-span-1 h-full'}>*/}
                {/*                <div className={'text-4xl sticky top-8 font-bold'}>*/}
                {/*                    {year}*/}

                {/*                </div>*/}
                {/*            </div>*/}
                {/*            <div className={'col-span-5 relative'}>*/}
                {/*                {items.map((item: IProjectItem) => {*/}
                {/*                    return <Project key={item.uuid} blok={item.content}/>*/}
                {/*                })}*/}
                {/*            </div>*/}
                {/*        </div>*/}
                {/*    </div>*/}
                {/*})}*/}

                {projects.map((item: IProjectItem) => {
                    return <Project key={item.uuid} blok={item.content}/>
                })}
            </InfiniteScroll>

            {/*<hr/>*/}
            {/*<div className={"grid grid-cols-6 gap-10"}>*/}
            {/*    <div className={"col-span-1 text-center text-gray-400  "}>*/}
            {/*        <ul className={'sticky top-5 shadow rounded-lg p-4'}>*/}
            {/*            <li className={"list-none"}>*/}
            {/*                Ongoing*/}
            {/*            </li>*/}

            {/*            {keys.map((year) => {*/}
            {/*                return <li key={year} className={"list-none"}>*/}
            {/*                    <a href={`#year-${year}`} className={'underline'}>*/}
            {/*                        {year}*/}
            {/*                    </a>*/}
            {/*                </li>*/}
            {/*            })}*/}
            {/*        </ul>*/}
            {/*    </div>*/}
            {/*    <div className="col-span-5 space-y-24 divide-y">*/}
            {/*        <div key={'ongoing'} id={`year-ongoing`}>*/}
            {/*            {ongoingItems.map((item: IProjectItem) => {*/}
            {/*                return <Project key={item.uuid} blok={item.content}/>*/}
            {/*            })}*/}

            {/*        </div>*/}

            {/*        {keys.map((year) => {*/}
            {/*            const items: Array<IProjectItem> = years.get(year);*/}

            {/*            return <div key={year} id={`year-${year}`}>*/}
            {/*                {items.filter(item => !item.content.ongoing).map(item => {*/}
            {/*                    return <Project key={item.uuid} blok={item.content}/>*/}

            {/*                })}*/}

            {/*            </div>*/}
            {/*        })}*/}
            {/*    </div>*/}
            {/*</div>*/}

        </section>
    )
}
